<template>
  <div>
    <v-card>
      <v-card-title class="pb-6">
        Integraciones Configuradas

        <v-spacer />

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          style="max-width: 400px"
        />
        <v-spacer />
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="configs"
        :search="search"
        :custom-filter="customFilter"
      >
        <template v-slot:item.NombreCompania="{ item }">
          [{{ item.IdCompania }}] {{ item.NombreCompania }}
        </template>
        <template v-slot:item.Channel="{ item }">
          {{ getChannelDescription(item.Channel) }}
        </template>
        <template v-slot:item.terminales="{ item }">
          <v-btn
            icon
            color="primary"
            @click="openTerminal(item)"
          >
            <v-icon>mdi-laptop</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="openLogs(item)">
                <v-list-item-icon>
                  <v-icon>mdi-file-code-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-title>
                  Descargar Logs
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="openReport(item)">
                <v-list-item-icon>
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-title>
                  Descargar
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:item.editar="{ item }">
          <v-btn
            icon
            color="warning"
            @click="editar(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <download-audit-dialog
      v-model="showDownloadDialog"
      :company="selectedCompany"
      :type="downloadType"
      @download="downloadAudit"
    />
  </div>
</template>
<script>
  import DownloadAuditDialog from './DownloadAuditDialog.vue'
  export default {

    components: {
      DownloadAuditDialog,
    },

    data () {
      return {

        search: '',

        showDownloadDialog: false,

        selectedCompany: null,

        downloadType: null,

        headers: [
          {
            text: 'Compañía',
            value: 'NombreCompania',
          },
          {
            text: 'Ambiente',
            value: 'Environment',
          },
          {
            text: 'Partner Code',
            value: 'PartnerCode',
          },
          {
            text: 'Canal',
            value: 'Channel',
          },
          {
            text: 'Terminales',
            value: 'terminales',
            sortable: false,
          },
          {
            text: 'Editar',
            value: 'editar',
            sortable: false,
          },
          {
            text: 'Acciones',
            value: 'acciones',
            sortable: false,
          },
        ],

        channelItems: [
          {
            text: 'Aplicación Móvil',
            value: 'O',
          },
          {
            text: 'POS (ERP)',
            value: 'L',
          },
          {
            text: 'Servicio Web',
            value: 'V',
          },
          {
            text: 'Portal Web del Cliente',
            value: 'W',
          },
          {
            text: 'Portal Web del Aliado',
            value: 'Z',
          },
        ],

      }
    },

    computed: {

      configs () {
        return this.$store.state
          .loyaltyPuntosColombia
          .configs
      },

    },

    created () {
      this.load()
    },

    methods: {

      openTerminal (item) {
        this.$emit(
          'terminales',
          item,
        )
      },
      editar (item) {
        this.$emit('editar', item)
      },

      load () {
        this.$store.dispatch(
          'loyaltyPuntosColombia/getConfigs',
        )
      },
      openLogs (item) {
        this.selectedCompany = item
        this.downloadType = 'logs'
        this.showDownloadDialog = true
      },

      openReport (item) {
        this.selectedCompany = item
        this.downloadType = 'report'
        this.showDownloadDialog = true
      },
      downloadAudit (data) {
        if (data.type === 'logs') {
          this.$store.dispatch(
            'loyaltyPuntosColombia/downloadAuditLogs',
            data,
          )

          return
        }

        this.$store.dispatch(
          'loyaltyPuntosColombia/downloadAuditReport',
          data,
        )
      },
      getChannelDescription (channel) {
        const channelItem = this.channelItems.find(
          item => item.value === channel,
        )

        return channelItem
          ? channelItem.text
          : channel
      },
      customFilter (value, search, item) {
        if (!search) {
          return true
        }

        const text = search.toString().toLowerCase()

        return (
          String(item.IdCompania || '')
            .toLowerCase()
            .includes(text) ||

          String(item.NombreCompania || '')
            .toLowerCase()
            .includes(text) ||

          String(item.Environment || '')
            .toLowerCase()
            .includes(text) ||

          String(item.PartnerCode || '')
            .toLowerCase()
            .includes(text)
        )
      },

    },

  }
</script>
